/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

const Message = (props) => {
  const {
    message,
    actions,
    onClose,
    isOpen,
    closeButtonTitle,
    secondaryActions
  } = props;
  return (
    isOpen && (
      <div className="detail-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="modal-message">{message}</p>
            </div>
            <div className="modal-footer">
              {Object.keys(actions).map((type) => (
                <button
                  type="button"
                  key={type}
                  className="btn btn-xs button-lavender"
                  onClick={() => {
                    if (actions[type].function) actions[type].function();
                    setTimeout(() => onClose(), 400);
                  }}
                >
                  <strong>{actions[type].name}</strong>
                </button>
              ))}

              {secondaryActions &&
                Object.keys(secondaryActions).map((type) => (
                  <button
                    type="button"
                    key={type}
                    className="btn btn-xs btn-default button-normal"
                    onClick={() => {
                      if (secondaryActions[type].function)
                        secondaryActions[type].function();
                      setTimeout(() => onClose(), 400);
                    }}
                  >
                    <strong>{secondaryActions[type].name}</strong>
                  </button>
                ))}

              <button
                type="button"
                className={`btn btn-xs btn-default ${
                  Object.keys(actions).length > 0
                    ? 'button-normal'
                    : 'button-lavender'
                }`}
                onClick={onClose}
              >
                <strong>{closeButtonTitle}</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

Message.propTypes = {
  message: PropTypes.any,
  actions: PropTypes.object,
  onClose: PropTypes.func
};

Message.defaultProps = {
  closeButtonTitle: 'Close'
};

export default Message;
